<template>
    <div class="scope-written box-shadow-small border-radius">
        <p class="mt-10 mb-20">
            <router-link to="/written"><i class="el-icon-arrow-left"></i>返回笔试列表</router-link>
        </p>
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px" class="mt-20">
            <el-row :gutter="100">
                <el-col :span="12">
                    <el-form-item label="考试标题" prop="title">
                        <el-input size="medium" v-model.trim="ruleForm.title"></el-input>
                    </el-form-item>
                    <el-form-item label="考生须知" prop="examRules">
                        <el-input type="textarea" v-model.trim="ruleForm.examRules"
                                  :autosize="{ minRows: 4, maxRows: 6}"
                                  resize="none" :maxlength="1000"></el-input>
                    </el-form-item>
                    <el-form-item label="选择笔试题" prop="paperIds">
                        <div class="pull-right">
                            <el-button v-if="ruleForm.paperIds.length===0" :disabled="true">预览试卷</el-button>
                            <el-button v-else-if="ruleForm.paperIds.length===1" @click="showPage(ruleForm.paperIds[0])">
                                预览试卷
                            </el-button>
                            <el-dropdown v-else>
                                <el-button :disabled="ruleForm.paperIds.length===0">
                                    预览试卷<i class="el-icon-caret-bottom el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-for="(item, index) in ruleForm.paperIds" :key="index"
                                                      @click.native="showPage(item)">{{getExamName(+item)}}
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <div style="overflow: hidden;padding-right: 20px;">
                            <el-select size="medium" multiple v-model="ruleForm.paperIds" class="mb-20" style="width: 100%;">
                                <el-option v-for="(item, index) in examLists" :key="index" :value="item.id"
                                           :label="item.name"></el-option>
                            </el-select>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12" class="pick-exam-time">
                    <el-form-item label="考试日期" required>
                        <el-date-picker type="date" placeholder="考试日期"
                                        ref="startDate"
                                        size="medium"
                                        :editable="false"
                                        :picker-options="pickerOptions"
                                        v-model="ruleForm.beginDate"></el-date-picker>
                        <span class="ml-10 color-gray">考试时长 <strong>{{durationTime}}</strong> 分钟，可安排多个时段，考生需提前选择一个时段</span>
                    </el-form-item>
                    <template v-for="(item, index) in ruleForm.timeDotArr">
                        <el-form-item class="time-dot"
                                      :prop="'timeDotArr.' + index + '.startTimeDot'"
                                      :rules="{required: true, message: '开始时间点不能为空', trigger: 'blur'}"
                                      :label="`时间段 ${index + 1}`">
                            <el-time-select v-model="item.startTimeDot"
                                            size="medium"
                                            :picker-options="item.pickerOptions"
                                            @change="changeTimeDot(item, index)"
                                            :editable="false"
                                            :clearable="false"
                                            placeholder="选择开始时间点">
                            </el-time-select>
                            <span class="ml-10">
                                <span class="color-gray mr-5">——</span> 结束时间：
                                <span class="end-time-holder">{{ item.endTimeDot }}</span>
                                <el-button v-if="index === 0" @click="addTimeDot" icon="el-icon-my-xinjian"
                                           type="text"></el-button>
                                <el-button v-else @click="removeTimeDot(index)" type="text"><i
                                        class="el-icon-my-shanchu color-danger"></i></el-button>
                            </span>
                        </el-form-item>
                    </template>
                </el-col>
            </el-row>
        </el-form>
        <div class="table-list mt-20">
            <el-table :data="lists">
                <el-table-column
                        label="候选人"
                        :show-overflow-tooltip="true"
                        align="center"
                        min-width="100">
                    <template slot-scope="scope">
                        {{ scope.row.name }}
                    </template>
                </el-table-column>
                <el-table-column
                        label="手机号"
                        :show-overflow-tooltip="true"
                        align="center"
                        min-width="100">
                    <template slot-scope="scope">
                        {{ scope.row.phone }}
                    </template>
                </el-table-column>
                <el-table-column
                        label="职位"
                        :show-overflow-tooltip="true"
                        align="center"
                        min-width="100">
                    <template slot-scope="scope">
                        {{ scope.row.positionName }}
                    </template>
                </el-table-column>
                <el-table-column
                        label="简历来源"
                        :show-overflow-tooltip="true"
                        align="center"
                        min-width="100">
                    <template slot-scope="scope">
                        {{ getSelectMapText('WB_RESUME_SOURCE', scope.row.resumeSource) || '-'}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="操作"
                        :show-overflow-tooltip="true"
                        align="center"
                        min-width="100">
                    <template slot-scope="scope">
                        <el-button type="text" @click="removeItem(scope.row.id)">移除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="text-center mt-20 mb-10">
            <el-button @click="cancelAndBack">取消</el-button>
            <el-button type="primary" :disabled="idsLength===0" @click="submitForm('ruleForm')">确认安排</el-button>
        </div>
    </div>
</template>
<script type="text/javascript">
    import selectMapMixin from 'mixins/selectMapMixin'
    import formCommonMixin from 'mixins/formCommonMixin'
    import multiMixin from './multiMixin'
    import {dateFormat} from 'modules/tools'

    const timeDot = {
        id: Date.now(),
        startTimeDot: '',
        endTimeDot: '',
        pickerOptions: {
            start: '09:00',
            step: '01:00',
            end: '22:00'
        }
    }

    export default {
        'mixins': [selectMapMixin, formCommonMixin, multiMixin],
        data () {
            return {
                ruleForm: {
                    beginDate: new Date(),
                    paperIds: [],
                    title: '',
                    examRules: '',
                    timeDotArr: [Object.assign({}, timeDot)]
                },
                rules: {
                    paperIds: {required: true, type: 'array', message: '请选择', trigger: 'change'},
                    examRules: {required: true, message: '请输入', trigger: 'blur'},
                    title: {required: true, message: '请输入', trigger: 'blur'}
                },
                pickerOptions: {
                    disabledDate (time) {
                        return time.getTime() < Date.now() - 8.64e7
                    }
                },
                examLists: [],
                pickedTimeDotArr: [],
                durationTime: 90,
                durationArr: [1, 30],
                removeTimeBool: false
            }
        },
        methods: {
            getExamName (id) {
                return this.examLists.filter(item => item.id === id)[0].name
            },
            showPage (id) {
                window.open(`${this.$router.options.base}written/topic/${id}?resumePositionId=&examId=`)
            },
            addTimeDot () {
                if (this.ruleForm.timeDotArr.length === 4) {
                    this.$message({
                        message: '时间段不能超过 4 个',
                        type: 'error'
                    })
                    return
                }
                this.ruleForm.timeDotArr.push(Object.assign({}, timeDot))
            },
            removeTimeDot (index) {
                this.pickedTimeDotArr.splice(index, 1)
                this.ruleForm.timeDotArr.splice(index, 1)
                this.removeTimeBool = true
            },
            changeTimeDot (item, index) {
                if (this.removeTimeBool === true) {
                    this.removeTimeBool = false
                    return
                }

                if (item.startTimeDot) {
                    if (this.pickedTimeDotArr.indexOf(item.startTimeDot) !== -1) {
                        this.$message.error('不能选择同一个时间段')
                        item.startTimeDot = ''
                        return
                    }

                    // 计算结束时间点
                    let timeArr = item.startTimeDot.split(':'),
                        hour = +timeArr[0]
                    item.endTimeDot = `${hour + this.durationArr[0]}:${this.durationArr[1]}`
                } else {
                    item.endTimeDot = ''
                }
                // 保存已选择的时间段
                this.pickedTimeDotArr[index] = item.startTimeDot
            },
            saveForm (boolean) {
                let date = dateFormat(this.ruleForm.beginDate)
                let postData = {
                    ids: this.ids,
                    title: this.ruleForm.title,
                    examRules: this.ruleForm.examRules,
                    paperIds: this.ruleForm.paperIds.join(','),
                    startTimeStr: this.ruleForm.timeDotArr.map(item => {
                        return `${date} ${item.startTimeDot}:00`
                    }).join(',')
                }
                this.$axios.post('/arrangeExam/saveNewArrange.api', postData, {'X-showMessage': true}).then(res => {
                    this.$router.replace({name: 'writtenList'})
                }).catch(console.error)
            },
            fetchCallback (res) {
                let duration = res.result.examDuration || 90,
                    durationInt = typeof duration === 'string' ? parseInt(duration) : duration,
                    min = durationInt % 60 === 0 ? '00' : durationInt % 60
                this.durationTime = durationInt
                this.durationArr = [parseInt(durationInt / 60), min]
            }
        },
        created () {
            this.fetchList()
            this.$axios.get('/arrangeExam/getAllPaper.api').then(res => {
                this.examLists = res.result.list
            }).catch(console.error)
            this.$axios.get('/arrangeExam/getExamTemplate.api').then(res => {
                // this.examLists = res.result.list
                let result = res.result.bean
                if (result) {
                    this.ruleForm.title = result.title
                    this.ruleForm.examRules = result.examRules
                }
            }).catch(console.error)
        }
    }
</script>
<style type="text/css" lang="scss">
    @import "~variable";

    .scope-written {
        margin  : $padding-width;
        padding : 10px 30px;
        .pick-exam-time {
            .color-gray {
                color : $text-color-third;
            }
            .time-dot {
                .el-form-item__label {
                    color : $text-color-third;
                }
            }
            .end-time-holder {
                display : inline-block;
                width   : 50px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// writtenArrangement.vue?87dbd5f0